import { IResponseInterface } from "../interfaces/api-response.interface";
import { HttpService } from "./base.service";

class UserSyncService extends HttpService {
  private readonly prefix: string = "user-sync";

  validateUserSync = (data:any): Promise<IResponseInterface<{ }>> => this.post(`${this.prefix}/validate`, data)

  processUserSync = (data:any): Promise<IResponseInterface<{ }>> => this.post(`${this.prefix}/process`, data)

  getOrgProcessedData = (id: string, page:number, fileName?: string): Promise<IResponseInterface<{ }>> => this.get(`${this.prefix}/organization/${id}?page=${page}&limit=20 ${fileName ? '&fileName=' + fileName : ''}`)

  getOrgProcessedCsvFiles = (id: string): Promise<IResponseInterface<{}>> => this.get(`${this.prefix}/organization/imported-files/${id}`);


  deleteOrgProcessedCsvFile = (data: any): Promise<IResponseInterface<{}>> => this.delete(`${this.prefix}/csv`,'',  data);


  // increaseShortcutCount = (shortcutId: string): Promise<IResponseInterface<{ }>> => this.post(`${this.prefix}/${shortcutId}/click`, {})

}
export const userSyncService = new UserSyncService();
